import React, { useState, useEffect } from 'react'
/* eslint-disable react/display-name */
/* eslint-disable no-unused-vars */
import { Col, Layout, Row, Table, Divider } from 'antd'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import dayjs from 'dayjs'
import isToday from 'dayjs/plugin/isToday'
import { printColumns } from '../../data/tableColumns'
import 'dayjs/locale/zh-cn'
import { OrderDetailResTypes, OrderItemsTypes } from '../../models/order/orderDetail'
import api from '../../config/api'

const { Content, Footer } = Layout
dayjs.extend(isToday)
const PrintStyle = styled(Row)`
  @media print {
    // margin: 0mm;
  }
`

const StyledContent = styled(Content)`
  overflow-y: auto;
  overflow-x: hidden;
  background-color: white;
  .ant-empty {
    display: none;
  }
`
const StyledHeader = styled.div`
  font-weight: 700;
  text-align: center;
  background-color: #fff;
`

const StyledFooter = styled(Footer)`
  position: sticky;
  top: 0;
  z-index: 10;
  color: black;
  font-weight: 500;
  text-align: center;
  background-color: #fff;
`

interface Props {
  id: string,
  lang: string,
  order?: OrderDetailResTypes
}
const PrintLayout = (props: Props) => {

  useEffect(() => {
    window.print()
  }, [])
  return (
    <>
      {props.order && (
        <Col span={24} style={{ marginTop: '20px' }}>
          <Layout>
            <StyledHeader>
              <Row>
                <Col span={12} style={{ textAlign: 'left', fontWeight: 'normal', padding: '10px' }}>
                  <span style={{ fontSize: '2.5rem' }}>INVOICE</span>
                  <br />
                  <span>
                    <br />
                    {props.lang === 'zh-CN' ? api.title : api.title_en} {api.www}
                    <br />
                    {props.lang === 'zh-CN' ? api.subtitle : api.subtitle_en}
                  </span>
                  <br />
                </Col>
                <Col span={12} style={{ textAlign: 'right', fontWeight: 'normal', padding: '10px' }}>
                  <br />
                  <FormattedMessage id='invoiceNo' />: {props.order.orderNo}
                  <br />
                  <FormattedMessage id='invoiceDate' />: {dayjs(props.order.createdAt).format('DD/MM/YYYY HH:mm')}
                  {props.order.paidAt > 0 ? (
                    <>
                      <br />
                      <FormattedMessage id='invoicePaidAt' />: {dayjs(props.order.paidAt).format('DD/MM/YYYY HH:mm')}
                    </>
                  ) : null}
                  <br />
                  <FormattedMessage id='invoiceGST' />: {api.gst}
                  <br />
                  <FormattedMessage id='casher' />: {props.order.managerName}
                </Col>
              </Row>
            </StyledHeader>

            <StyledContent>
              <Row>
                <Col span={12} style={{ textAlign: 'left', fontWeight: 'normal', padding: '10px' }}>
                  {props.order.shipmentMethod.shippingTerm === 'pickup' ? (
                    <Row>
                      <Col span={24}>
                        {props.order.shipmentMethodName}
                      </Col>
                      <Col span={24}>
                        {props.order.pickupStoreName} {props.order.pickupStorePhone} {props.order.pickupStoreAddress}
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      {props.order.shipmentGroupId != 4 ? (
                        <Col span={24}>
                          GST exempt for all export orders
                        </Col>
                      ) : null}
                      <Col span={24}>
                        <FormattedMessage id='shipping' />:{' '}{props.order.shipmentMethodName}
                      </Col>
                      <Col span={24}>
                        <FormattedMessage id='address' />: {props.order.consigneeName} {props.order.consigneeAddress} {props.order.consigneePhone}
                      </Col>
                    </Row>
                  )}
                </Col>
                <Col span={12} style={{ textAlign: 'right', fontWeight: 'normal', padding: '10px' }}>
                  <span style={{ fontWeight: 'bold' }}><FormattedMessage id='customer' /></span>: #{props.order.customerNo}
                  {props.order.customerCompany ? (
                    <span style={{ paddingLeft: '5px' }}>{props.order.customerCompany}</span>
                  ) : (
                    <span style={{ paddingLeft: '5px' }}>{props.order.customerName} {props.order.customerPhone}</span>
                  )}
                  {props.order.customerAddress ? (
                    <>
                      <br />
                      {props.order.customerAddress}
                    </>
                  ) : null}
                </Col>
              </Row>
              <Table
                size='small'
                rowKey='id'
                columns={printColumns}
                dataSource={props.order?.items}
                pagination={false}
                footer={() => {
                  return (
                    <Row justify='space-between' style={{ marginTop: '10px' }}>
                      <Col xs={0} sm={12} lg={16}></Col>
                      <Col xs={24} sm={12} lg={8}>
                        <Row justify='space-between'>
                          <Col>
                            <FormattedMessage id='subtotal' />
                          </Col>
                          <Col>${props.order.subtotal.toFixed(2)}{props.order.lang === 'zh-CN' && props.order.currencyRate != 0 && props.order.currencyRate != 1 ? (<span> /￥{(props.order.subtotal * props.order.currencyRate).toFixed(2)}</span>) : null}</Col>
                        </Row>
                        {props.order.totalWeight != 0 ? (
                          <Row justify='space-between'>
                            <Col>
                              <FormattedMessage id='totalWeight' />
                            </Col>
                            <Col>{props.order.totalWeight.toFixed(3)}kg</Col>
                          </Row>
                        ) : null}
                        {props.order.shipmentMethod.shippingTerm != 'pickup' ? (
                          <Row justify='space-between'>
                            <Col>
                              <FormattedMessage id='shippingFee' />
                            </Col>
                            <Col>${props.order.shippingFee.toFixed(2)}{props.order.lang === 'zh-CN' && props.order.currencyRate != 0 && props.order.currencyRate != 1 ? (<span> /￥{(props.order.shippingFee * props.order.currencyRate).toFixed(2)}</span>) : null}</Col>
                          </Row>
                        ) : null}
                        {props.order.discounts.length > 0
                          ? props.order.discounts.map((item) => {
                            if (item.discountAmount != 0) {
                              return (
                                <Row justify='space-between' key={item.id}>
                                  <Col>
                                    <FormattedMessage id={item.discountType} />
                                  </Col>
                                  <Col>- ${item.discountAmount.toFixed(2)}{props.order.lang === 'zh-CN' && props.order.currencyRate != 0 && props.order.currencyRate != 1 ? (<span> /￥{(item.discountAmount * props.order.currencyRate).toFixed(2)}</span>) : null}</Col>
                                </Row>
                              )
                            }
                          })
                          : null}
                        {props.order.surcharge != 0 ? (
                          <Row justify='space-between'>
                            <Col>
                              <FormattedMessage id='surcharge' />
                            </Col>
                            <Col>${props.order.surcharge.toFixed(2)}{props.order.lang === 'zh-CN' && props.order.currencyRate != 0 && props.order.currencyRate != 1 ? (<span> /￥{(props.order.surcharge * props.order.currencyRate).toFixed(2)}</span>) : null}</Col>
                          </Row>
                        ) : null}
                        <Row justify='space-between'>
                          <Col>
                            <span style={{ fontWeight: 'bold' }}><FormattedMessage id='total' /></span>
                          </Col>
                          <Col>${props.order.total.toFixed(2)}{props.order.lang === 'zh-CN' && props.order.currencyRate != 0 && props.order.currencyRate != 1 ? (<span> /￥{(props.order.total * props.order.currencyRate).toFixed(2)}</span>) : null}</Col>
                        </Row>
                        {props.order.totalGST > 0 ? (
                          <Row justify='space-between'>
                            <Col>
                              <span style={{ fontWeight: 'bold' }}><FormattedMessage id='invoiceGSTAmount' /></span>
                            </Col>
                            <Col>${props.order.totalGST.toFixed(2)}{props.order.lang === 'zh-CN' && props.order.currencyRate != 0 && props.order.currencyRate != 1 ? (<span> /￥{(props.order.totalGST * props.order.currencyRate).toFixed(2)}</span>) : null}</Col>
                          </Row>
                        ) : null}
                        {props.order.totalPaid > 0 ? (
                          <Row justify='space-between'>
                            <Col>
                              <FormattedMessage id='totalPaid' />
                            </Col>
                            <Col>${props.order.totalPaid.toFixed(2)}{props.order.lang === 'zh-CN' && props.order.currencyRate != 0 && props.order.currencyRate != 1 ? (<span> /￥{(props.order.totalPaid * props.order.currencyRate).toFixed(2)}</span>) : null}</Col>
                          </Row>
                        ) : null}

                        <Row justify='space-between'>
                          <Col>
                            <span style={{ fontWeight: 'bold' }}><FormattedMessage id='totalDue' /></span>
                          </Col>
                          <Col>${props.order.totalDue.toFixed(2)}{props.order.lang === 'zh-CN' && props.order.currencyRate != 0 && props.order.currencyRate != 1 ? (<span> /￥{(props.order.totalDue * props.order.currencyRate).toFixed(2)}</span>) : null}</Col>
                        </Row>
                      </Col>
                      {api.payment != '' ? (
                        <Col xs={24} style={{ marginTop: '20px' }}><Row><span style={{ fontWeight: 'bold' }}><FormattedMessage id='payment' /></span></Row><Row>{api.payment}</Row></Col>
                      ) : null}
                    </Row>
                  )
                }
                }
              />
            </StyledContent>
            <StyledFooter>
              <div>---------- ***** ----------</div>
              <div><FormattedMessage id='invoiceFooter' /></div>
            </StyledFooter>
          </Layout>
        </Col>
      )}
    </>
  )
}

export default PrintLayout
